module.exports = __webpack_public_path__ + "static/theme-editor-carousel-7d7fbe941e66caa592cbf2eaed7277fa.png";